import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_84133)">
                <path
                    d="M13.125 7.96875C14.3992 8.88589 15.9301 9.37796 17.5 9.375V6.25C16.3397 6.25 15.2269 5.78906 14.4064 4.96859C13.5859 4.14812 13.125 3.03532 13.125 1.875H10V12.1875C9.99984 12.5789 9.89464 12.9631 9.69539 13.3001C9.49614 13.637 9.21014 13.9143 8.86721 14.103C8.52428 14.2917 8.137 14.385 7.74575 14.3731C7.3545 14.3611 6.97362 14.2444 6.64284 14.0351C6.31207 13.8258 6.04351 13.5316 5.86519 13.1831C5.68686 12.8347 5.6053 12.4448 5.62902 12.0541C5.65273 11.6633 5.78085 11.2861 6.00001 10.9618C6.21917 10.6375 6.52134 10.3779 6.875 10.2102V6.875C4.38828 7.31797 2.5 9.57344 2.5 12.1875C2.5 13.5965 3.05971 14.9477 4.056 15.944C5.05228 16.9403 6.40354 17.5 7.8125 17.5C9.22146 17.5 10.5727 16.9403 11.569 15.944C12.5653 14.9477 13.125 13.5965 13.125 12.1875V7.96875Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_84133">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconProfilePencil;
